// What a patient enters to join a video consultation, chosen per practice (KIN-1953).
// Names are the default; date of birth is for practices whose patients' names don't
// match the record reliably (spellings, hyphens, middle names).
export const VIDEO_JOIN_VERIFICATION = {
  NAME_AND_YEAR_OF_BIRTH: "NAME_AND_YEAR_OF_BIRTH",
  DATE_OF_BIRTH: "DATE_OF_BIRTH",
};

export const DEFAULT_VIDEO_JOIN_VERIFICATION =
  VIDEO_JOIN_VERIFICATION.NAME_AND_YEAR_OF_BIRTH;

// The `v` an invite link carries to pick the join form. Only the name form has one; v=3, and
// no v at all, open the date-of-birth form.
export const NAME_AND_YEAR_OF_BIRTH_LINK_VERSION = "4";
